import React, { Component } from 'react'
import { Layout, Breadcrumb } from 'antd'
import './EUSHoldRelease.scss'
import { withRouter } from 'react-router-dom'
import DPLscreeningTable from '../../components/DPLscreeningTable/DPLscreeningTable'
import EUSHoldRelease from '../../components/EUSHoldRelease/EusHoldrelease'
const { Content } = Layout

class DKInventory extends Component {
  render() {
    return (
      <div className="CatalogManagementStyles">
        <EUSHoldRelease />
      </div>
    )
  }
}

export default withRouter(DKInventory)
